const tipBox = [
  "M1.76 3.47C.81 3.47 0 4.27 0 5.22v5.25c0 .96.81 1.75 1.76 1.75h4.56a1 1 0 0 0 1-1 1 1 0 0 0-1-1H2V5.47h4.94a1 1 0 0 0 .06.14.92.92 0 0 0-.4.08c-.42.2-.62.67-.42 1.08a.71.71 0 0 0 .23.27l4.27 3.1a.17.17 0 0 1 .07.16.2.2 0 0 1-.12.16l-1.58.73h-.01c-.36.17-.52.57-.38.89a.6.6 0 0 0 .2.23l.26.18a.2.2 0 0 0 .15.04l3.03-.48A3.15 3.1 0 0 0 14.2 11l1.4-1.63c.42-.47.52-1.08.27-1.6a1.42 1.4 0 0 0-.45-.54l-1.86-1.34c-.26-.19-.6-.24-.92-.14l-2.15.65c-.44.13-.77.51-.81.93L8.03 6.14a1 1 0 0 0 .81-.92c0-.96-.8-1.75-1.76-1.75H1.76z"
];
export {
  tipBox
};
//# sourceMappingURL=tipBox.js.map
